export default {
      id: "ar_culture-usage",
      viewBox: "0 0 140 100",
      url: "../dist/images/" + "sprite.svg#ar_culture-usage",
      toString: function () {
        return this.url;
      }
    }